import { Component } from 'preact'
import { extractRenderPropsChildren } from '../../../libs/renderProps'
import InputGroup from '../../ui-components/InputGroup'
import { BaseFilterSelectorBuilderData, FilterSelectorProps } from './interfaces'
import { FilterSelector } from '@insided/deprecated-control/overview/filters/FiltersMenu'

interface RadioInputFilterSelectorItem {
  id: string | number
  name: string
  value: string
}

interface CommonProps {
  items: RadioInputFilterSelectorItem[]
}

interface State {
  condition: string
  data: string | number
}

type BuilderData = BaseFilterSelectorBuilderData & CommonProps

type Filter = FilterSelector & CommonProps

type Props = FilterSelectorProps<State> & CommonProps

class RadioInputFilterSelector extends Component<Props, State> {
  static create = (config: BuilderData): Filter => ({
    component: this,
    type: 'filter',
    getPillDisplayValue: ({ condition, data }: State): string => {
      const item = config.items.find((i) => i.value === condition)

      return `${item?.name} ${data}`
    },
    ...config
  })

  constructor(props: Props) {
    super(props)
    this.state = {
      condition: props.selectedFilterItems?.condition || '',
      data:
        typeof props.selectedFilterItems?.data !== 'undefined'
          ? Number(props.selectedFilterItems.data)
          : ''
    }
  }

  setCondition = (condition: string) => {
    const { data } = this.state
    this.setState({ condition, data })
  }

  setData = (data: string) => {
    const { condition } = this.state
    this.setState({ condition, data })
  }

  render() {
    const { id, name, items, children } = this.props
    const { condition, data } = this.state

    return (
      <div>
        <div className='overview__filters-box-content'>
          {items.map((item) => {
            const checked = condition === item.value
            return (
              <div key={item.id}>
                <InputGroup
                  inline
                  qaClasses={`qa-filter-input-${item.value}`}
                  key={item.id}
                  name={name}
                  value={item.value}
                  title={item.name}
                  type='radio'
                  formGroupClasses='overview__filters-box-filter'
                  checked={checked}
                  onChange={(e) => this.setCondition(e.target.value)}
                />
                {checked && (
                  <InputGroup
                    inline
                    qaClasses='qa-radio-filter-input'
                    name={name}
                    value={data}
                    title={id}
                    type='number'
                    min={0}
                    formGroupClasses='overview__filters-data-input'
                    onKeyUp={(e) => this.setData(e.target.value)}
                    onChange={(e) => this.setData(e.target.value)}
                  />
                )}
              </div>
            )
          })}
        </div>
        {extractRenderPropsChildren(children)({
          data: { ...this.state, data: Number(data) },
          isApplyButtonDisabled: !condition || data === ''
        })}
      </div>
    )
  }
}

export default RadioInputFilterSelector
